import fetch from "./feche";

// POST /admin/login 管理用户登录
export function adminLogin(data) {
  return fetch({
    url: "/user/login",
    method: "post",
    data,
  });
}

export function changePassword(data) {
  return fetch({
    url: "/changePassword",
    method: "post",
    ...data,
  });
}

// 重置密码
export function resetPassword(user = "") {
  return fetch({
    url: "/updatePassword?userName=" + user,
    method: "post",
  });
}

export function getMonthRadio(data) {
  return fetch({
    url: "/index/getMonthRadio",
    method: "get",
    params: data,
  });
}

export function getOrderIntakeSecnod(data) {
  return fetch({
    url: "/getOrderIntakeSecnod",
    method: "get",
    params: data,
  });
}

export function getOrderIntake(data) {
  return fetch({
    url: "/getOrderIntake",
    method: "get",
    params: data,
  });
}

export function getOrderIntakeThere(data) {
  return fetch({
    url: "/getOrderIntakeThere",
    method: "get",
    params: data,
  });
}

export function getOne(data) {
  return fetch({
    url: "/index/getOne",
    method: "get",
    params: data,
  });
}
export function getTwo(data) {
  return fetch({
    url: "/index/getTwo",
    method: "get",
    params: data,
  });
}
export function getThere(data) {
  return fetch({
    url: "/index/getThere",
    method: "get",
    params: data,
  });
}
export function getThere2(data) {
  return fetch({
    url: "/index/getThere2",
    method: "get",
    params: data,
  });
}
export function getFour(data) {
  return fetch({
    url: "/index/getFour",
    method: "get",
    params: data,
  });
}

export function getFive(data) {
  return fetch({
    url: "/index/getFive",
    method: "get",
    params: data,
  });
}
export function getFive2(data) {
  return fetch({
    url: "/index/getFive2",
    method: "get",
    params: data,
  });
}

export function getChildUser(data) {
  return fetch({
    url: "/getChildUser",
    method: "get",
  });
}

// 意向列表新增查询VpSales
export function getVpSalesInfo(data) {
  return fetch({
    url: "/getVpSalesInfo",
    method: "get",
  });
}

export function getDeptSingle(data) {
  return fetch({
    url: "/getDeptSingle",
    method: "get",
    params: data,
  });
}
// export function getIndexCountryList(data) {
//   return fetch({
//     url: "/index/getIndexCountryList",
//     method: "get",
//     params: data,
//   });
// }

export function getIndexCountryList(data) {
  return fetch({
    url: "/getNewCountryList",
    method: "get",
    params: data,
  });
}
export function getCountryList(data) {
  return fetch({
    url: "/getCountryList",
    method: "get",
  });
}
export function getCityByCountry(data) {
    return fetch({
        url: "/getCityByCountry",
        method: "get",
        params: data
    });
}
export function getCustomer(data) {
  return fetch({
    url: "/getCustomer",
    method: "get",
    params: data,
  });
}

export function getOverdueReceivable(data) {
  return fetch({
    url: "/getOverdueReceivable",
    method: "get",
    params: data,
  });
}

export function getCustomerDetail(data) {
  return fetch({
    url: "/getCustomerDetail",
    method: "get",
    params: data,
  });
}

export function getCustomerDetailStat(data) {
  return fetch({
    url: "/getCustomerDetailStat",
    method: "get",
    params: data,
  });
}

export function getCustomerDetailSalesSort(data) {
  return fetch({
    url: "/getCustomerDetailSalesSort",
    method: "get",
    params: data,
  });
}

export function getShippingAbnormal(data) {
  return fetch({
    url: "/getShippingAbnormal",
    method: "get",
    params: data,
  });
}

export function getLineUp(data) {
  return fetch({
    url: "/getLineUpList",
    method: "get",
    params: data,
  });
}

export function getCustomerdiscountsummary(data) {
  return fetch({
    url: "/getCustomerdiscountsummary",
    method: "get",
    params: data,
  });
}

export function getGoOutList(data) {
  return fetch({
    url: "/mwhGoOutData/getGoOutList",
    method: "get",
    params: data,
  });
}

export function getGoOutDetail(data) {
  return fetch({
    url: "/mwhGoOutData/getGoOutDetail",
    method: "get",
    params: data,
  });
}

export function addGoOut(data) {
  return fetch({
    url: "/mwhGoOutData/addGoOut",
    method: "POST",
    data,
  });
}

export function modifyGoOut(data) {
  return fetch({
    url: "/mwhGoOutData/modifyGoOut",
    method: "POST",
    data,
  });
}

export function getNsra16List(data) {
  return fetch({
    url: "/getNsra16List",
    method: "get",
    params: data,
  });
}

export function getOverdueAccountReceivablesGraph(data) {
  return fetch({
    url: "/getOverdueAccountReceivablesGraph",
    method: "get",
    params: data,
  });
}

export function getOverdueAccountReceivables(data) {
  return fetch({
    url: "/getOverdueAccountReceivables",
    method: "get",
    params: data,
  });
}

export function readyCtnsToShipGraph(data) {
  return fetch({
    url: "/readyCtnsToShipGraph",
    method: "get",
    params: data,
  });
}

export function readyCtnsToShipGraphTable(data) {
  return fetch({
    url: "/readyCtnsToShipGraphTable",
    method: "get",
    params: data,
  });
}

export function readyCtnsToShipGraphSecondTable(data) {
  return fetch({
    url: "/readyCtnsToShipGraphSecondTable",
    method: "get",
    params: data,
  });
}

export function readyCtnsToShip(data) {
  return fetch({
    url: "/readyCtnsToShip",
    method: "get",
    params: data,
  });
}

export function getOrderCountBySatusGroupByKunnr(data) {
  return fetch({
    url: "/getOrderCountBySatusGroupByKunnr",
    method: "get",
    params: data,
  });
}

export function getOrderCountBySatusGroup(data) {
  return fetch({
    url: "/getOrderCountBySatusGroup",
    method: "get",
    params: data,
  });
}

export function getOrder(data) {
  return fetch({
    url: "/getOrder",
    method: "get",
    params: data,
  });
}

export function getOrderDetail(data) {
  return fetch({
    url: "/getOrderDetail",
    method: "get",
    params: data,
  });
}

export function getOrderExcel(data) {
  return fetch({
    url: "/getOrderExcel",
    method: "get",
    params: data,
  });
}
export function getCustomerOrderAverageDelivery(data) {
  return fetch({
    url: "/getCustomerOrderAverageDelivery",
    method: "post",
    data
  });
}

// 出口总体货期
export function getCustomerOverallDelivery(data) {
  return fetch({
    url: "/getCustomerOverallDelivery",
    method: "post",
    data
  });
}

// 订单号查询
export function getAllOrderNumberInfos(data) {
    return fetch({
        url: "/getAllOrderNumberInfos",
        method: "post",
        data
    });
}

// 订单进度可视 明细信息 分页
export function getCustomerOverallDeliveryDetail(data) {
  return fetch({
    url: "/getCustomerOverallDeliveryDetail",
    method: "post",
    data
  });
}

// 导出订单进度可视 明细信息
export function exportCustomerOverallDeliveryDetail(data) {
  return fetch({
    url: "/exportCustomerOverallDeliveryDetail",
    method: "post",
    data
  });
}

export function exportCustomerOrderAverageDelivery(data) {
  return fetch({
    url: "/exportCustomerOrderAverageDelivery",
    method: "post",
    data,
    responseType:'blob'
  });
}

export function getExportSalesAnalysisPerModel(data) {
  return fetch({
    url: "/getExportSalesAnalysisPerModel",
    method: "get",
    params: data,
  });
}

export function getExportSalesAnalysisPerColor(data) {
  return fetch({
    url: "/getExportSalesAnalysisPerColor",
    method: "get",
    params: data,
  });
}

export function getExportSalesAnalysisPerCustomer(data) {
  return fetch({
    url: "/getExportSalesAnalysisPerCustomer",
    method: "get",
    params: data,
  });
}

export function getCustomerContainerTackingGraph(data) {
  return fetch({
    url: "/getCustomerContainerTackingGraph",
    method: "get",
    params: data,
  });
}

export function getCustomerContainerTackingReport(data) {
  return fetch({
    url: "/getCustomerContainerTackingReport",
    method: "get",
    params: data,
  });
}

export function getCustomerContainerTackingTwoReport(data) {
  return fetch({
    url: "/getCustomerContainerTackingTwoReport",
    method: "get",
    params: data,
  });
}

export function getCustomerContainerTacking(data) {
  return fetch({
    url: "/getCustomerContainerTacking",
    method: "get",
    params: data,
  });
}

export function getCompetingGoods(data) {
  return fetch({
    url: "/competinggood/getCompetingGoods",
    method: "get",
    params: data,
  });
}

export function getCompetingGoodsDetail(data) {
  return fetch({
    url: "/competinggood/getCompetingGoodsDetail",
    method: "get",
    params: data,
  });
}

export function getModelList(data) {
  return fetch({
    url: "/getModelList",
    method: "get",
    params: data,
  });
}

export function getCommodityGroupList(data) {
  return fetch({
    url: "/getCommodityGroupList",
    method: "get",
    params: data,
  });
}

export function getSelectList(data) {
  return fetch({
    url: "/getSelectList",
    method: "get",
    params: data,
  });
}

export function getCommodityGroupPrice(data) {
  return fetch({
    url: "/getCommodityGroupPrice",
    method: "get",
    params: data,
  });
}

export function getCommodityGroupAllPrice(data) {
  return fetch({
    url: "/getCommodityGroupAllPrice",
    method: "get",
    params: data,
  });
}

// POST /addDocument 添加文档
export function addDocument(data) {
  return fetch({
    url: "/addDocument",
    method: "post",
    data,
  });
}

// 批量上传文档
export const uploadDocuments = (data) => {
  return fetch({
    url: "/addDocumentBath",
    method: "post",
    data,
    unConvert: true
  });
};


// GET /getDocumentsList 查询文档列表
export function getDocumentsList(data) {
  return fetch({
    url: "/getDocumentsList",
    method: "get",
    params: data,
  });
}
// DELETE /deleteDocument 删除文档 改为POST请求
export function deleteDocument(data) {
  return fetch({
    url: "/deleteDocument",
    method: "POST",
    data,
  });
}
// POST /modifyDocuments 编辑文档
export function modifyDocuments(data) {
  return fetch({
    url: "/modifyDocuments",
    method: "POST",
    data,
  });
}

// GET /getDocumentsType 新增查询文档类型列表
export function getDocumentsType(data) {
  return fetch({
    url: "/getDocumentsType",
    method: "get",
    params: data,
  });
}
// GET /getDocumentsType 页面默认查询文档类型列表
export function getDocumentsTypes(data) {
  return fetch({
    url: "/getDocumentsTypeCounts",
    method: "get",
    params: data,
  });
}

// POST /addMarket 新增展会
export function addMarket(data) {
  return fetch({
    url: "/addMarket",
    method: "POST",
    data,
  });
}
// GET /getMarketList 展会列表
export function getMarketList(data) {
  return fetch({
    url: "/getMarketList",
    method: "get",
    params: data,
  });
}
// GET /deleteMarket 删除展会
export function deleteMarket(data) {
  return fetch({
    url: "/deleteMarket",
    method: "get",
    params: data,
  });
}

// POST /modifyMarket 编辑展会
export function modifyMarket(data) {
  return fetch({
    url: "/modifyMarket",
    method: "POST",
    data,
  });
}
// POST /addMarketDetail 添加展会详情信息
export function addMarketDetail(data) {
  return fetch({
    url: "/addMarketDetail",
    method: "POST",
    data,
  });
}
// GET /getMarketDetail 展会详情
export function getMarketDetail(data) {
  return fetch({
    url: "/getMarketDetail",
    method: "get",
    params: data,
  });
}
// POST /modifyMarketDetail 编辑展会详情商品信息
export function modifyMarketDetail(data) {
  return fetch({
    url: "/modifyMarketDetail",
    method: "post",
    data,
  });
}
//DELETE /deleteMarketDetail 删除展会详情信息
export function deleteMarketDetail(data) {
  return fetch({
    url: "/deleteMarketDetail",
    method: "DELETE",
    params: data,
  });
}

// POST /addCommodity  添加商品

export function addCommodity(data) {
  return fetch({
    url: "/addCommodity",
    method: "post",
    data,
  });
}
// POST /modifyCommodity 编辑商品信息

export function modifyCommodity(data) {
  return fetch({
    url: "/modifyCommodity",
    method: "post",
    data,
  });
}
// POST /addPerformance 添加业绩
export function addPerformance(data) {
  return fetch({
    url: "/addPerformance",
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
    method: "post",
    data,
  });
}

// GET /getPerformanceList 业绩列表
export function getPerformanceList(data) {
  return fetch({
    url: "/getPerformanceList",
    method: "get",
    params: data,
  });
}

// POST  /uploadExcel 导入业绩表
export function uploadExcel(data) {
  return fetch({
    url: "/uploadExcel",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    params: data,
  });
}

// GET /getPerformanceExcel 业绩导出Excel
export function getPerformanceExcel(data) {
  return fetch({
    url: "/getPerformanceExcel",
    method: "GET",
    params: data,
  });
}

// GET /getNewPerformanceExcel 业绩导出Excel
export function getNewPerformanceExcel(data) {
  return fetch({
    url: "/getNewPerformanceExcel",
    method: "GET",
    params: data,
  });
}

// GET /exportGoOutExcel 导出报表
export function exportGoOutExcel(data) {
  return fetch({
    url: "/mwhGoOutData/exportGoOutExcel",
    method: "GET",
    responseType: "blob",
    params: data,
  });
}

// POST /competinggood/add 添加竞品
export function addCompetinggood(data) {
  return fetch({
    url: "/competinggood/add",
    method: "post",
    data,
  });
}
/*
  GET
  /getCommodityQuotationExcel
  导出商品报价单
*/
export function getCommodityQuotationExcel(data) {
  return fetch({
    url: "/getCommodityQuotationExcel",
    method: "GET",
    params: data,
  });
}

// getMarketOrderList 展会报表
export function getMarketOrderList(data) {
  return fetch({
    url: "/getMarketOrderList",
    method: "GET",
    params: data,
  });
}

// getLineupExcel Lineup报表
export function getLineupExcel(data) {
  return fetch({
    url: "/getLineupExcel",
    method: "GET",
    params: data,
  });
}
// /getMarketDetailExcel MarketDetail导出Excel
export function getMarketDetailExcel(data) {
  return fetch({
    url: "/getMarketDetailExcel",
    method: "GET",
    params: data,
  });
}
// 获取展会统计
export function getTotalCommitments(data) {
  return fetch({
    url: "/getTotalCommitments",
    method: "GET",
    params: data,
  });
}
// 获取展会统计Excel
export function getTotalCommitmentsExcel(data) {
  return fetch({
    url: "/getTotalCommitmentsExcel",
    method: "GET",
    params: data,
  });
}
// 获取新客户列表
export function getNewCustomerList(data) {
  return fetch({
    url: "/getNewCustomerList",
    method: "GET",
    params: data,
  });
}
// 获取展会列表
export function getCommitmentsList(data) {
  return fetch({
    url: "/getCommitmentsList",
    method: "GET",
    params: data,
  });
}
//
export function getCommitmentsListExcel(data) {
  return fetch({
    url: "/getCommitmentsListExcel",
    method: "GET",
    params: data,
  });
}
// 删除出差
export function deleteGoOut(data) {
  return fetch({
    url: "/mwhGoOutData/deleteGoOut",
    method: "GET",
    params: data,
  });
}

// Customer客户模块--导出excel接口
export function getCustomerExcel(data) {
  return fetch({
    url: "/getCustomerExcel",
    method: "GET",
    params: data,
  });
}

// 品牌下拉框
export function getBrandList(data) {
  return fetch({
    url: "/getBrandList",
    method: "GET",
    params: data,
  });
}

// 接口描述：获取款式
export function getModels(data) {
  return fetch({
    url: "/getModels",
    method: "GET",
    params: data,
  });
}

// 接口描述：获取颜色
export function getCovers(data) {
  return fetch({
    url: "/getCovers",
    method: "GET",
    params: data,
  });
}
//展会颜色列表
// 展会颜色列表
export const getCoverList = (params = {}) => {
  // 1. 浅拷贝参数对象，避免直接修改源对象产生难以追踪的副作用
  const processedParams = { ...params };
  // 2. 边界处理：当 mId 为 null、undefined 时，强制转换类型
  // 【关键配置】：绝大多数 Java/Node 后端将空字符串 `?mId=` 解析为 null。
  // 如果你们后端严格要求必须是 `?mId=null` 这个字眼，请将下面的 '' 改为 'null'
  if (processedParams.mId === null || processedParams.mId === undefined) {
    processedParams.mId = ""; // 若需严格字符串，改为 "null"
  }
  return fetch({
    url: "/getMarketCovers",
    method: "GET",
    params: processedParams
  });
};
// 接口描述：获取规格
export function getArrangements(data) {
  return fetch({
    url: "/getCategories",
    method: "GET",
    params: data,
  });
}

// 新增意向客户
export function addCustomer(data) {
  return fetch({
    url: "/addMwhMarketDetails",
    method: "POST",
    data,
  });
}

// 接口描述：意向新增获取用户
export function getCustomerByAdd(data) {
  return fetch({
    url: "/getCustomerByAdd",
    method: "GET",
    params: data,
  });
}

// 品牌下拉框
export function getCoversByFabirc(data) {
  return fetch({
    url: "/getCoversByFabirc",
    method: "GET",
    params: data,
  });
}

export function getNewChildUser() {
  return fetch({
    url: "/getNewChildUser",
    method: "get",
  });
}

// 获取事业部
export function getNewChildDepByID() {
  return fetch({
    url: "/getNewChildDepByID",
    method: "get",
  });
}

// 通过部门获取VpSales
export function getVpSalesByDep(data){
  return fetch({
    url: "/getVpSalesByDep",
    method: "GET",
    params: data,
  });
}

//通过localstorage获取 lang
export function getLang() {
  return localStorage.getItem("lang");
}

// 通用的导入文件接口
export function uploadFile(data) {
  return fetch({
    url: "/uploadFile",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "post",
    data,
    upload: true,
  });
}

// 查询颜色下拉
export function getDictionaryData() {
  return fetch({
    url: "/getDictionaryData",
    method: "get",
    params: {
      tableName: 'color'
    }
  });
}

// 通用的导入文件接口(不管控)
export function commonUploadFile(data) {
  return fetch({
    url: "/common/commonUploadFile",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "post",
    data,
    upload: true,
  });
}

// 获取国家下拉框通过部门搜索
export function getNewCountryListByDep() {
    return fetch({
        url: "/mwhCustomerInfo/getNewCountryListByDep",
        method: "get"
    });
}

// 通过国家代码获取到地区信息
export function getAllAreaByCountry(data){
    return fetch({
        url: "/mwhCustomerInfo/getAllAreaByCountry",
        method: "get",
        params: data
    });
}

// 通过国家地区获取到业务信息
export function  getChildUserByCountryAndArea(data){
    return fetch({
        url: "/mwhCustomerInfo/getChildUserByCountryAndArea",
        method: "get",
        params: data
    });
}

// 新LineUp
export function  getNewLineUpListTotal(data){
  return fetch({
    url: "/getNewLineUpListTotal",
    method: "get",
    params: data
  });
}

// LineUp 添加额外信息
export function  addLinupAdditionalInfo(data){
  var langtype = localStorage.getItem("lang") == "cn" ? 1 : "E";
  return fetch({
    url: `/addLinupAdditionalInfo?language=${langtype}`,
    method: "post",
    data
  });
}

// 导出LineUp
export function  exporttNewLineUpListTotal(data){
  return fetch({
    url: "/exporttNewLineUpListTotal",
    method: "get",
    params: data
  });
}

// 添加Line数据到摆场信息
export function  addCustomerLinupInfoToFloorSlot(data){
  var langtype = localStorage.getItem("lang") == "cn" ? 1 : "E";
  return fetch({
    url: `/addCustomerLinupInfoToFloorSlot?language=${langtype}`,
    method: "post",
    data,
    unConvert: true
  });
}

// 删除Line数据到摆场信息
export function  deleteCustomerLinupInfoToFloorSlot(data){
  var langtype = localStorage.getItem("lang") == "cn" ? 1 : "E";
  return fetch({
    url: `/deleteCustomerLinupInfoToFloorSlot?language=${langtype}`,
    method: "post",
    data,
    unConvert: true
  });
}

// 通用品类查询
export function  getGeneralCategory(){
  return fetch({
    url: '/exportSalesData/getGeneralCategory',
    method: "get"
  });
}

// 通用档次查询
export function  getGeneralLevel(){
  return fetch({
    url: '/exportSalesData/getGeneralLevel',
    method: "get"
  });
}

// 获取展会国家
export function getMarketCountryList(data) {
  return fetch({
    url: "/getMarketCountryList",
    method: "get",
    params: data,
  });
}

// 根据VP获取展会
export function getMarketListByVpSales(data) {
  return fetch({
    url: "/getMarketListByVpSales",
    method: "get",
    params: data,
  });
}
export const exportCountDetails=(params)=>{
  return fetch({
    url:'/exportOrderCountBySatusGroupByKunnr',
    method:'get',
    params
  })
}

// 销售净额分析报表汇总

export const exportSalesNetSum=(params)=>{
  return fetch({
    url:'/getNsra16Total',
    method:'get',
    params
  })
}

//lineup 导出
export const exportLineUpList=(params)=>{
  return fetch({
    url:'/exportNewLineUpInfo',
    method:'get',
    params,
  })
}

// next年预算添加需要单独传输接口
export  const addNextYearBudget=(data)=>{
  return fetch({
    url:'/addLinupAdditionalInfo',
    method:'post',
    data
  })
}
//获取客户信息资料表
export const getCustomerInfo=(data)=>{
  return fetch({
    url:'/customerInfo/getCustomerInfo',
    method:'post',
    data
  })
}

//vp折扣率
export const exportVpDiscount=(params)=>{
  return fetch({
    url:'/getVpSalesDiscountRate',
    method:'get',
    params,
  })
}

//vp折扣率第二层=> 客户折扣率
export const  customerDiscount=(params)=>{
  return fetch({
    url:'/getVpSalesCustomerDiscountRate',
    method:'get',
    params,
  })
}

// vp折扣率第三层 => 客户折扣率明细
export const  customerDiscountDetail=(params)=>{
  return fetch({
    url:'/getVpSalesCustomerDiscountRateInfo',
    method:'get',
    params,
  })
}
